import axios from 'axios';
import { OctResponse } from '../../models/OctResponse';
import {
	IDichVuChuaCoKetQua,
	IDonThuocMauRequest,
	IDonThuocMauSearchParams,
	IInPhieuChiDinhThuocParams,
} from '../models/ThuocModels';
import { localStorageItem } from '../../utils/LocalStorage';
import { KEY_LOCALSTORAGE } from '../../auth/core/_consts';
import { WarehouseSearchParams } from '../models/VatTuModels';
import { APP_CONFIGURATION_KEYS } from '../../utils/Constant';

const BASE_URL = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.WAREHOUSE_URL] || process.env.REACT_APP_WMS_API_URL;
const CIS_BASE_URL = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.API_URL] || process.env.REACT_APP_API_URL;

export const validateDonThuoc = async (params: any): Promise<OctResponse<any>> => {
	const { data } = await axios.post<OctResponse<any>>(
		`${CIS_BASE_URL}/medical-item-group/validate-create`,
		params
	);
	return data;
};

export const saveDonThuoc = async (
	params: any,
	callbackFn?: any
): Promise<OctResponse<any>> => {
	const { data } = await axios.post<OctResponse<any>>(
		`${CIS_BASE_URL}/medical-item-group/save`,
		params,
		{ callback: callbackFn }
	);
	return data;
};

export const deleteDonThuoc = async (id: string): Promise<OctResponse<any>> => {
	const { data } = await axios.delete<OctResponse<any>>(
		`${CIS_BASE_URL}/medical-item-group/delete-by-id/${id}`
	);
	return data;
};

export const getDrugListById = async (params: object): Promise<OctResponse<any>> => {
	const { data } = await axios.post<OctResponse<any>>(
		`${CIS_BASE_URL}/medical-item-order/search`,
		params
	);
	return data;
};

export const getDetailDonThuoc = async (drugId: string, orderId?: string): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(
		`${CIS_BASE_URL}/medical-item-group/get-by-id/${drugId}`,
		{ params: { orderId } }
	);
	return data;
};

export const getDrugGroupListByVisitId = async ({
	orderId,
	type,
}: {
	orderId: string;
	type: string;
}): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(
		`${CIS_BASE_URL}/medical-item-group/get-list-by-clinical-order-id/${orderId}/and-type/${type}`
	);
	return data;
};

export const getDetailThuoc = async (thuocId: string): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(`${BASE_URL}/item/${thuocId}`);
	return data;
};

export const printPhieuChiDinhThuoc = async (params: IInPhieuChiDinhThuocParams) => {
	return await axios.post<Blob>(`${CIS_BASE_URL}/medical-item-group/export`, params, {
		responseType: 'blob',
	});
};

export const getDichVuChuaCoKetQua = async ({
	patientId,
	visitId,
}: {
	patientId: string;
	visitId: string;
}): Promise<OctResponse<IDichVuChuaCoKetQua[]>> => {
	const { data } = await axios.get<OctResponse<IDichVuChuaCoKetQua[]>>(
		`${CIS_BASE_URL}/medical-item-group/get-no-result-order-by-patient-id` +
		`/${patientId}/and-visit-id/${visitId}`
	);
	return data;
};

export const getDanhSachDonThuocCu = async (): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(
		`${CIS_BASE_URL}/`
	);
	return data;
};

export const getDrugDetailById = async (
	drugId: string | number,
	params: {
		warehouseId: number;
		serialNumber: string;
		consignment: string; 
	}
): Promise<any> => {
	const { data } = await axios.get<OctResponse<any>>(
		`${BASE_URL}/item/get-item-by-id-and-consigment/${drugId}`,
		{
			params,
		}
	);
	return data;
};

export const huyGuiDonThuoc = async (id: string): Promise<OctResponse<any>> => {
	const { data } = await axios.patch<OctResponse<any>>(
		`${CIS_BASE_URL}/medical-item-group/cancel-items/${id}`,
	);
	return data;
};

export const getWarehouse = async (params: WarehouseSearchParams) => {
	const { data } = await axios.post<OctResponse<any>>(`${BASE_URL}/warehouse/search`, {
		...params,
		pageIndex: params.pageIndex ?? 1,
		pageSize: params.pageSize ?? 999,
	});
	return data;
};

export const getTermByClassIds = async (classIds: string | number): Promise<any> => {
	const { data } = await axios.get(`${BASE_URL}/term-classes/terms`, { params: { classIds } });
	return data;
};

export const saveDonThuocDVKT = async (
	payload: any,
	callbackFn?: any,
	orderId?: string,
	isReturn?: boolean
): Promise<OctResponse<any>> => {
	const { data } = await axios.post<OctResponse<any>>(
		`${CIS_BASE_URL}/medical-item-group/order/${orderId}/${isReturn ? "return-consumables" : "consumables"}/save`,
		payload,
		{ callback: callbackFn }
	);
	return data;
};

export const getDonThuocDVKT = async (orderId: string, type: string, isReturn?: boolean): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(
		`${CIS_BASE_URL}/medical-item-group/order/${orderId}/${isReturn ? "return-consumables" : "consumables"}`,
		{ params: { type } }
	);
	return data;
};

export const getDsThuocVatTuDVKT = async (orderId: string, isReturn?: boolean): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(
		`${CIS_BASE_URL}/medical-item-group/order/${orderId}/${isReturn ? "return-consumables" : "consumables"}/items/all`
	);
	return data;
};

export const getMedicalItemsByType = async ({ visitId, type }: { visitId: string; type: string }) => {
	const { data } = await axios.get(
		`${CIS_BASE_URL}/medical-item-group/get-list-by-visit-id/${visitId}/and-type/${type}`
	);
	return data;
};
